import React from 'react';
import './Policy.css';

const Policy = () => {
    return (
            <div class="policy py-5">
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-12 col-md-4 p-3 col-xl-3 m-4 policy-border">
        <img alt="" class="fdb-icon" src="https://i.ibb.co/4tGbjCk/icon-policy-1.png"/>
        <h3>EXPRESS SHIPPING</h3>
        <span>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</span>
      </div>

      <div class="col-12 col-md-4 p-3 col-xl-3 m-4 policy-border">
        <img alt="" class="fdb-icon" src="https://i.ibb.co/hKQdJZ9/icon-policy-2.png"/>
        <h3>PAYMENT SECURED</h3>
        <span>Separated they live in Bookmarksgrove right at the coast of the Semantics, a large ocean.</span>
      </div>

      <div class="col-12 col-md-4 p-3 col-xl-3 m-4 policy-border">
        <img alt="" class="fdb-icon" src="https://i.ibb.co/806b7zg/icon-policy-3.png"/>
        <h3>MONEY BACK GUARANTEE</h3>
        <span>A small river named Duden flows by their place and supplies it with the necessary regelialia</span>
      </div>
    </div>
  </div>
</div>

    );
};

export default Policy;